export default "__VITE_ASSET__YaP0N77M__"